// Import all actions
import * as actions from '../actions/uiActions'

export const initialState = {
  hideSideMenu: false
}

export default function uiReducer(state = initialState, action) {
  switch (action.type) {
    case actions.HIDE_SIDEMENU:
      return { ...state, hideSideMenu: !state.hideSideMenu }
    default:
      return state
  }
}